'use strict';

var appDom = require('./app-dom');

var introClass = 'app--is-slideshow-intro';
var state;

var isActive = function() {

	return state && state.introTimer;

};

var stop = function() {

	if (isActive()) {

		window.clearTimeout(state.introTimer);

	}

	state = null;

	appDom.body.removeClass(introClass);

};

var start = function() {

	appDom.body.addClass(introClass);

	state = {};

	state.introTimer = window.setTimeout(stop, 2000);

};

module.exports = {

	isActive: isActive,
	start: start,
	stop: stop

};
